import { ButtonIcon } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Components/Icons/Close";
import { buttonResetStyles } from "@store/theme/mixins";
import { css } from "styled-components";

const drawerBackgroundColor = "common.background";

export default {
    defaultProps: {
        size: 310,
        cssOverrides: {
            drawerBody: css`
                background-color: ${getColor(drawerBackgroundColor)};
            `,
            drawerTitle: css`
                background-color: ${getColor(drawerBackgroundColor)};
            `,
            titleButton: css`
                ${buttonResetStyles()}
                margin-right: 12px;
                width: 24px;
                height: 24px;
                color: ${getColor("text")};

                ${ButtonIcon} {
                    color: inherit;
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 12,
        },
    },
};
